module.exports = __webpack_public_path__ + "img/virtual_tour.3a17e1b4.jpg";